import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddquestiongameLayer } from '../components/questiongame/AddquestiongameLayer'

export const AddQuestiongamePage = () => {
  return (
    <MasterLayout>
        <AddquestiongameLayer />
    </MasterLayout>
  )
}
